import PropTypes from 'prop-types';

export default PropTypes.shape({
  columnName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.object]),
  operation: PropTypes.string,
});
